module.exports = __webpack_public_path__ + "img/features-speech.19a1c5b0.svg";